export const GET_ALL_ORG = "GET_ALL_ORG"
export const GET_SINGLE_ORG = "GET_SINGLE_ORG"
export const ADD_ORG = "ADD_ORG"
export const UPDATE_ORG = "UPDATE_ORG"
export const DELETE_ORG = "DELETE_ORG"
export const GET_ALL_ACT_STATE = "GET_ALL_ACT_STATE"